import $axios from '@/axios-instance.js'

export const priceListService = {
  getByCustomerId,
  getByProjectCode
}

function getByCustomerId (customerId) {
  return $axios.get(`${process.env.ROOT_API}/price-lists/customer-id/${customerId}`).then(response => {
    return response.data
  })
}

function getByProjectCode (projectCode) {
  return $axios.get(`${process.env.ROOT_API}/price-lists/project-code/${projectCode}`).then(response => {
    return response.data
  })
}



// WEBPACK FOOTER //
// ./src/services/price-list.service.js